import { UserContext } from '@fortem-monorepo/react-spa'

import { LINKED_PERMISSIONS } from '@/constants/linked-permissions'
import { ROLE, ROLES } from '@/constants/roles'

const getDataFromRoles = (...roles: ROLE[]) => {
  return {
    roles,
    permissions: [...new Set(roles.map((role) => LINKED_PERMISSIONS[role]).flat())],
  }
}

export const testUsers: Array<UserContext['user']> = [
  {
    user: {
      name: 'CEO',
      email: 'mr.ceo@fortemcapital.com',
    },
    ...getDataFromRoles(ROLES.READ_ONLY_ADMIN),
  },
  {
    user: {
      name: 'Ops Team',
      email: 'john.doe@fortemcapital.com',
    },
    ...getDataFromRoles(ROLES.OPERATIONS_CONTRIBUTOR),
  },
  {
    user: {
      name: 'Operations Graduate',
      email: 'john.doe3@fortemcapital.com',
    },
    ...getDataFromRoles(ROLES.OPERATIONS_VIEWER),
  },
  {
    user: {
      name: 'Trading Team',
      email: 'john.doe4@fortemcapital.com',
    },
    ...getDataFromRoles(ROLES.TRADING_CONTRIBUTOR),
  },
  {
    user: {
      name: 'John Doe 2',
      email: 'john.doe2@fortemcapital.com',
    },
    ...getDataFromRoles(ROLES.ASSET_MANAGEMENT_CONTRIBUTOR),
  },
  {
    user: {
      name: 'Sales person',
      email: 'john.doe2@fortemcapital.com',
    },
    ...getDataFromRoles(ROLES.SALES_VIEWER),
  },
]
